import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Profile from "../../assets/PNG/profile.webp";
import { jwtDecode } from "jwt-decode";
import { useTranslation } from "react-i18next";

const Header = () => {

  const { t, i18n } = useTranslation();

  const [token, setToken] = useState(null);        // raw token string or null
  const [decoded, setDecoded] = useState(null);    // decoded claims or null
  const [userName, setUserName] = useState("");
  const [avatar, setAvatar] = useState(Profile);
  const [userRole, setUserRole] = useState("");
  const navigate = useNavigate();

  const syncUser = () => {
    const t = localStorage.getItem("Finder-token") || null;
    const name = localStorage.getItem("name") || "";
    const av = localStorage.getItem("avatar") || Profile;
    const role = localStorage.getItem("userRole") || "";

    setToken(t);
    setUserName(name);
    setAvatar(av);
    setUserRole(role);

    if (t && typeof t === "string") {
      try {
        const d = jwtDecode(t);
        setDecoded(d);
      } catch (e) {
        console.error("Invalid token in storage:", e);
        // optional: clear bad token so app doesn't loop on error
        localStorage.removeItem("Finder-token");
        setToken(null);
        setDecoded(null);
      }
    } else {
      setDecoded(null);
    }
  };

  useEffect(() => {
    syncUser();
    const handleAuthChange = () => syncUser();
    window.addEventListener("authChanged", handleAuthChange);
    return () => window.removeEventListener("authChanged", handleAuthChange);
  }, []);

  const goToProfile = () => {
    if (userRole === "admin" || userRole === "agent") {
      navigate("/dashboard/profile");
    } else {
      navigate("/home/profile");
    }
  };

  const handleLogin = () => navigate("/signin");
  const handleSignup = () => navigate("/signup");

  return (
    <header className="lg:block sticky hidden top-0 z-50 bg-gray-800 text-white px-6 py-3  h-[100px] shadow-lg">
      <div className="flex items-center justify-between">
 <img
                src={"/logo.png"}
                alt="Profile"
                className="w-20 h-20 rounded-full "
              />
        <nav className="flex space-x-8">
          {token && (userRole === "admin" || userRole === "agent") ? (
            <>
              <Link to="/dashboard" className="hover:text-red-400">{t("home")}</Link>
              <Link to="/dashboard/createlist" className="hover:text-red-400"> {t("post")}</Link>
              <Link to="/dashboard/profile" className="hover:text-red-400"> {t("profile")}</Link>
            </>
          ) : (
            <>
              <Link to="/home" className="hover:text-red-400"> {t("home")}</Link>
              <Link to="/home/saved" className="hover:text-red-400"> {t("saved")}</Link>
              <Link to="/home/profile" className="hover:text-red-400"> {t("profile")}</Link>
            </>
          )}
        </nav>

        <div className="flex items-center space-x-4">
          {token ? (
            <button
              type="button"
              onClick={goToProfile}
              className="group relative flex items-center gap-2 focus:outline-none"
              aria-label="Open profile"
            >
              <img
                src={avatar}
                alt="Profile"
                className="w-10 h-10 rounded-full ring-1 ring-black/5"
              />
              <span className="font-semibold text-red-400 hidden sm:inline">
                {userName || decoded?.name || "User"}
              </span>

              {/* Hover card (guards against undefined decoded) */}
              <div
                role="tooltip"
                className="pointer-events-none absolute -bottom-16 left-1/2 -translate-x-1/2 whitespace-nowrap
                  rounded-lg bg-black/80 px-2.5 py-1 text-xs text-white opacity-0 shadow
                  transition-opacity duration-150 group-hover:opacity-100"
              >
                <div className="font-semibold text-[13px] truncate">
                  {userName || decoded?.name || "—"}
                </div>
                <div className="mt-0.5 text-[12px] text-gray-200 truncate">
                  {decoded?.email || "—"}
                </div>
                <div className="mt-0.5 text-[12px] text-gray-200">
                  {decoded?.phone || "—"}
                </div>
                <span className="absolute -top-1 left-1/2 -translate-x-1/2 h-2 w-2 rotate-45 bg-black/80 rounded-[2px]" />
              </div>
            </button>
          ) : (
            <>
              <button
                onClick={handleLogin}
                className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
              >
                {t("login")}
              </button>
              <button
                onClick={handleSignup}
                className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
              >
                {t("signup")}
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
